import * as actionTypes from './actions';

const getCurrentDateStartTimeUTC = (currentDate) => {
  const date = currentDate ? new Date(currentDate) : new Date();
  const istTime = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 2, 30, 0, 0));
  return istTime.toUTCString();
};

const getCurrentDateEndTimeUTC = (currentDate) => {
  const date = currentDate ? new Date(currentDate) : new Date();
  return date.toUTCString();
};

export const initialState = {
  isOpen: [],
  defaultId: 'default',
  fontFamily: 'Roboto',
  borderRadius: 8,
  opened: true,
  currentDate: new Date().toISOString(),
  selectedTime: {
    start_time: getCurrentDateStartTimeUTC(new Date().toISOString()),
    end_time: getCurrentDateEndTimeUTC(new Date().toISOString())
  },
  selectedZone: 'all',
  isExpanded: false,
  videoSource: '',
  departments: []
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (state = initialState, action) => {
  let id;
  switch (action.type) {
    case actionTypes.MENU_OPEN:
      id = action.id;
      return {
        ...state,
        isOpen: [id]
      };
    case actionTypes.SET_CAMERA_SOURCE:
      return {
        ...state,
        videoSource: action.videoSource
      };
    case actionTypes.SET_MENU:
      return {
        ...state,
        opened: action.opened
      };
    case actionTypes.SET_FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.fontFamily
      };
    case actionTypes.SET_BORDER_RADIUS:
      return {
        ...state,
        borderRadius: action.borderRadius
      };
    case actionTypes.CURRENT_DATE:
      return {
        ...state,
        currentDate: action.currentDate
      };
    case actionTypes.SELECTED_TIME:
      return {
        ...state,
        selectedTime: action.selectedTime
      };
    case actionTypes.SET_SELECTED_ZONES:
      return {
        ...state,
        selectedZone: action.selectedZone
      };
    case actionTypes.SIDEBAR_STATE:
      return {
        ...state,
        isExpanded: action.isExpanded
      };
    case actionTypes.SET_DEPARTMENTS:
      return {
        ...state,
        departments: Array.isArray(action.departments) ? action.departments : []
      };
    default:
      return state;
  }
};

export default customizationReducer;
